import { render, staticRenderFns } from "./period-component.vue?vue&type=template&id=3f6c4ba4&scoped=true&"
import script from "./period-component.vue?vue&type=script&lang=js&"
export * from "./period-component.vue?vue&type=script&lang=js&"
import style0 from "./period-component.vue?vue&type=style&index=0&id=3f6c4ba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c4ba4",
  null
  
)

export default component.exports